import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AppProviders } from './app/providers';
import { router } from './app/router';
import './index.css';
// Validates env at startup; logs missing variable NAMES only (no values).
import './lib/env';
// PWA service worker (V1-03): registers in production builds only —
// vite.config.ts keeps dev/test SW-free. Update seam: src/pwa/register-sw.ts.
import { setupServiceWorker } from './pwa/register-sw';
// New-release detection (timer / tab focus / reconnect + version.json), the
// one-shot reload on a stale route chunk, and the shared "update available"
// state every shell renders a bar from. Production builds only: dev has no
// version.json and the component tests must never see an unmocked fetch.
import { startUpdateWatch } from './pwa/update';
// The install event fires before React mounts, so it is captured here.
import { watchInstallPrompt } from './pwa/install';
import { build } from './lib/build';

setupServiceWorker();
if (!import.meta.env.DEV) startUpdateWatch();
watchInstallPrompt();

// The one line support asks for first: which build is this device on?
console.info(`sg-console ${build.sha}${build.builtAt ? ` built ${build.builtAt}` : ''}`);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
